import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import mutations from './mutations';
import modules from './modules';

Vue.use(Vuex);

const store = new Vuex.Store({
  // root
  state: {
    // 鉴权用户信息
    user: {},
    // 鉴权token
    token: '',
    // 系统用户信息
    sysUser: {},
    // 当前用户的全部权限
    perms: [],
    // amis editor
    amisEditor: {
      visible: false,
      id: '',
      path: '',
      json: '',
    },
  },
  getters: {
    // 权限信息, 权限相关在layout层每次刷新有效，不再做状态管理；
    // perms: state => [...(state.sysUser.permission || [])],
    // adv userId, 基本用与对接adv系统账号
    advUserId: (state) => state.sysUser.adv_user_id || '',
    // 检查权限
    checkPerm: (state) => (op) => (state.perms || []).includes(op),
  },
  mutations,
  actions,
  modules,
});

if (module.hot) {
  module.hot.accept(['./actions', './mutations'], () => {
    store.hotUpdate({
      actions: require('./actions').default,
      mutations: require('./mutations').default,
    });
  });
}

export default store;
